export const ticketReviewConstants = {
  REPLACE_FILE_BTN: "Replace File",
  REPLACE_TKT_BTN: "Replace Ticket",
  SUBMIT_TKT_BTN: "Submit for Data Input",
  SIGNED_BY_CUSTOMER: "Signed By Customer",
  TICKET_PROGRESS_LABEL: "Ticket Approved",
  REPLACE_TKT_BTN_CLASS: "replaceSingleTicketButton",
  SUBMIT_TKT_BTN_CLASS: "submitSingleTicketButton",
  SIGNED_CHECKBOX_NAME: "signedByCustomer",
  PROGRESS_STROKE_COLOR: "#28E648",
  PROGRESS_STATUS: "normal",
  SUCCESS: "Success",
};

export const errorAlertAlt = "Error Alert Icon";

export const successNotificationStyle = {
  backgroundColor: "#F1FFEE",
  borderRadius: "0.875rem",
  marginRight: "-1.875rem",
};

export const modalMessages = {
  customerConfirmation:
    "Are you sure want to proceed without confirming the Customer's signature",
  uploadTitle: "Upload Ticket",
  uploadFile: "Upload File",
  replaceTicketTitle: "Replace Ticket",
  replaceTicketContent: "Do you want to replace this individual ticket?",
  replaceFile: "Replace File",
  replaceFileContent:
    "Do you want to replace all tickets in this batch (including approved ones)",
  uploadDraggerModalWidth: "761px",
  confirmWithoutSignature: "Yes",
  cancelWithoutSignature: "No",
  buttonClass: "actionButtonClass",
  replaceButtonConfirmLabel: "Yes",
  replaceButtonCancelLabel: "No",
  uploadButtonConfirmLabel: "Upload",
  uploadButtonCancelLabel: "Cancel",
};

export const notificationMessages = {
  success: "Ticket Moved For Data Input",
  replaceFile: "File Replaced Succesfully",
  replaceTkt: "Ticket replaced successfully",
  replaceTktError:
    "Only single-page PDFs are allowed. Please upload a One-Page PDF",
};
